import { Note } from "../note/Note"
import { AuditableResponse } from "../common/AuditableResponse"

export class CustomerDetails extends AuditableResponse {
  id: number

  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  addressLine1: string
  addressLine2: string
  city: string
  stateId?: number
  postalCode: string

  notes: Note[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, firstName?: string, lastName?: string, phoneNumber?: string, email?: string, addressLine1?: string, addressLine2?: string, city?: string, stateId?: number, postalCode?: string, notesJson?: any, createdByUserJson?: any, createdDate?: string, lastModifiedByUserJson?: any, lastModifiedDate?: string) {
    super(createdByUserJson, createdDate, lastModifiedByUserJson, lastModifiedDate)

    this.id = id
    this.firstName = firstName ?? ''
    this.lastName = lastName ?? ''
    this.phoneNumber = phoneNumber ?? ''
    this.email = email ?? ''
    this.addressLine1 = addressLine1 ?? ''
    this.addressLine2 = addressLine2 ?? ''
    this.city = city ?? ''
    this.stateId = stateId
    this.postalCode = postalCode ?? ''
    
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notesJson ? notesJson.map((n: any) => new Note(n.id, n.content, n.customerVisible, n.lastModifiedByUser, n.lastModifiedDate)) : []
  }
}
